/**
 * /projects/new — wizard for creating a project from a template (PR 12
 * stage C). Backend endpoint: POST /api/simulate/create_project_from_template
 * (PMO/Admin only). The page itself is reachable by any authenticated
 * role; the role gate kicks in at the simulate-mutation step and surfaces
 * a 403 toast — so a lead / viewer landing here by typing the URL
 * still see the UI but cannot proceed past step 2.
 */
import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { AppShell } from "@/layout/AppShell";
import { Button } from "@/components/ui/button";
import { NewProjectWizard } from "@/components/projects/wizard/NewProjectWizard";

export function NewProjectPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <AppShell>
      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-semibold">{t("projects.new.title")}</h1>
        <Button asChild variant="ghost" size="sm">
          <Link to="/projects" data-testid="new-project-back">
            {t("projects.new.backToList")}
          </Link>
        </Button>
      </div>
      <p className="text-muted-foreground mt-1 text-sm">{t("projects.new.subtitle")}</p>
      <div className="mt-6">
        <NewProjectWizard />
      </div>
    </AppShell>
  );
}
